import { styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { dataGridColumns } from "./ListingsDataGridColumnDefinitions";

const StyledDataGrid = styled(DataGrid)({
    border: "none",
    "& .MuiDataGrid-cell": {
        padding: "10px",
        display: "flex",
        alignItems: "center",
        fontSize: "13px",
    },
    "& .MuiDataGrid-columnHeaders": {
        borderBottom: "1px solid rgb(212, 212, 212)",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        fontWeight: 500,
    },
    "& .MuiDataGrid-row": {
        borderBottom: "1px solid rgb(240, 240, 240)",
    },
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
});

const StyledDataGridDiv = styled("div")({
    width: "100%",
    overflowX: "auto",
});

const BrokerRequestedListingTable = (props) => {
    const {
        clearListingsTab,
        elementsSaving,
        getListingsByStatusSortAndGrouping,
        isGrouped,
        listings,
        listingTab,
        role,
        setListingsSort,
    } = props;

    const [sortListingOrAddress, setSortListingOrAddress] = useState("property.primaryAddress");
    const listingsForTab = listings[listingTab];
    const [rows, setRows] = useState([]);
    const columns = dataGridColumns(sortListingOrAddress, setSortListingOrAddress, isGrouped)[listingTab];

    useEffect(() => {
        getListingsByStatusSortAndGrouping(listingTab, isGrouped);
        return () => {
            clearListingsTab(listingTab);
        };
    }, [isGrouped]);

    useEffect(() => {
        setRows(initRows());
    }, [listingsForTab]);

    const buildGroupedListingRows = () => {
        return Object.keys(listingsForTab).flatMap((propKey) => {
            let propertyRow;
            const property = Object.values(listingsForTab[propKey])[0].property;
            propertyRow = {
                id: propKey,
                isGrouped: true,
                property: property,
                listingsLength: listingsForTab[propKey].length,
            };
            const listingRows = listingsForTab[propKey].map((listing) => {
                return buildRow(listing);
            });
            return [propertyRow, ...listingRows];
        });
    };

    const buildUngroupedListingRows = () => {
        return Object.values(listingsForTab).map((listing) => {
            return buildRow(listing);
        });
    };

    const buildRow = (listing) => {
        const row = { id: listing.listingKey, isPropertyRow: false };
        for (const column of columns) {
            row[column.field] = listing[column.field];
        }
        row["listing"] = listing;
        row["role"] = role;
        return row;
    };

    const initRows = () => {
        if (!listingsForTab) {
            return [];
        }
        if (isGrouped) {
            return buildGroupedListingRows();
        } else {
            return buildUngroupedListingRows();
        }
    };

    const handleSortModelChange = (newSortModel) => {
        const newSort =
            newSortModel[0]?.field && newSortModel[0]?.sort
                ? newSortModel[0]?.field === "property"
                    ? `${sortListingOrAddress},${newSortModel[0].sort}`
                    : `${newSortModel[0].field},${newSortModel[0].sort}`
                : null;
        setListingsSort(newSort);
        getListingsByStatusSortAndGrouping(listingTab, isGrouped);
    };

    return (
        <StyledDataGridDiv>
            <StyledDataGrid
                columns={columns}
                rows={rows}
                autoHeight
                getRowHeight={() => "auto"}
                disableColumnMenu
                disableColumnResize
                hideFooter
                onSortModelChange={handleSortModelChange}
                sortingMode="server"
                pageSizeOptions={[-1]}
                loading={elementsSaving[listingTab]}
                slotProps={{
                    loadingOverlay: {
                        variant: "circular-progress",
                        noRowsVariant: "circular-progress",
                    },
                }}
            />
        </StyledDataGridDiv>
    );
};

export default BrokerRequestedListingTable;
